export const eventConstants = {

    EVENT_SUCCESS: 'EVENT_SUCCESS',
    EVENT_ERROR: 'EVENT_ERROR',
    EVENT_REQUEST: 'EVENT_REQUEST',
    EVENT_VIEW_SUCCESS:'EVENT_VIEW_SUCCESS'

}
